<template>
  <v-content>
    <!-- Dummy -->
  </v-content>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import service from '@/plugins/service'

export default {
  async mounted() {
    // ログインチェック
    let user = {}
    try {
      user = await service.authCheck()
    } catch (e) {
      service.log(e)
      this.$router.replace('/signIn/signInTemp')
      return
    }
    // Profile完成チェック
    const isProfileComplete = await service.isProfileComplete(user.uid)
    if (!isProfileComplete) {
      this.setNextRoute('/likes')
      this.$router.replace('/myProfile')
    } else {
      // LikeListに遷移
      this.$router.push('/likes')
    }
  },
  methods: {
    ...mapActions('storage', [
      'setNextRoute',
    ]),
  },
}
</script>
